import React from 'react';
import { Router, IndexRedirect, Route, Redirect, IndexRoute } from 'react-router';
import { GlobalStyle } from '@acast/decibel';
import App from 'routes/app';
import EpisodePage from 'routes/episode';
import EpisodeEditorPage from 'routes/episode/editor';
import EpisodePublishPage from 'routes/episode/publish';
import EpisodeSettingsPage from 'routes/episode/settings';
import EpisodeAccessSettingsPage from 'routes/episode/access-settings';
import LogoutPage from 'routes/logout';
import NotFoundPage from 'routes/not-found';
import OverviewPage from 'routes/overview';
import RedeemInvite from 'routes/redeem-invite';
import ShowPage from 'routes/show';
import NewShowPage from 'routes/show/new-show-page';
import ShowEpisodes from 'routes/show/show-episodes-page';
import ShowSettings from 'routes/show/show-settings-page';
import ShowSettingsGeneral from 'routes/show/show-settings-page/general';
import ShowSettingsAccess from 'routes/show/show-settings-page/access';
import SignUser from 'routes/sign-user';

const renderLegacyRedirects = () => <Redirect from="/login" to="/" />;

export default function(history) {
  return (
    <>
      <GlobalStyle appRootSelector="#react-app" />
      <Router history={history}>
        <Route path="/" component={App}>
          <IndexRoute component={OverviewPage} />
          <Redirect from="overview" to="/" />
          <Route path="episodes/:episodeId" component={EpisodePage}>
            <IndexRedirect to="settings" />
            <Route path="settings" component={EpisodeSettingsPage} />
            <Route path="editor" component={EpisodeEditorPage} />
            <Route path="publish" component={EpisodePublishPage} />
            <Route path="access-settings" component={EpisodeAccessSettingsPage} />
          </Route>
          <Route path="shows">
            <Route path="new" component={NewShowPage} />
            <Route path=":showId" component={ShowPage}>
              <IndexRedirect to="episodes" />
              <Route path="episodes" component={ShowEpisodes} />
              <Route path="settings" component={ShowSettings}>
                <IndexRoute component={ShowSettingsGeneral} />
                <Route path="access" component={ShowSettingsAccess} />
              </Route>
            </Route>
          </Route>
        </Route>

        {renderLegacyRedirects()}

        <Route path="/redeem/:inviteId" component={RedeemInvite} />
        <Route path="/sign" component={SignUser} />
        <Route path="/sign/:token" component={SignUser} />
        <Route path="/logout" component={LogoutPage} />
        <Route path="/404" component={NotFoundPage} />
        <Redirect from="*" to="/404" />
      </Router>
    </>
  );
}
